import Api from "./Api";

const endpoint = "/benutzerverwaltung";
export default {
    get() {
        var usedParams = {};
        return Api.fetchData(endpoint + "/user");
    },
    getAccessMap(id) {
        var usedParams = {};
        return Api.fetchData(endpoint + "/user/accessmap/" + id);
    },
    putAccessMap(id, data) {
        return Api.putData(endpoint + "/user/accessmap/" + id, data);
    },
    getSettings(id) {
        return Api.fetchData(endpoint + "/user/settings/" + id);
    },
    getSetting(id, key) {
        return Api.fetchData(endpoint + "/user/settings/" + id + "/key/" + key);
    },
    putSettings(id, data) {
        return Api.putData(endpoint + "/user/settings/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint + "/user", data);
    },
    put(id, data) {
        return Api.putData(endpoint + "/user/" + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/user/" + id);
    },
    resetPassword(id) {
        return Api.putData(endpoint + "/user/password/forget", {
            id: id
        });
    },
    getGroups() {
        return Api.fetchData(endpoint + "/groups");
    },
    postGroup(data) {
        return Api.postData(endpoint + "/groups", data);
    },
    putGroup(id, data) {
        return Api.putData(endpoint + "/groups/" + id, data);
    },
    deleteGroup(id) {
        return Api.deleteData(endpoint + "/groups/" + id);
    }
};
